import { isUndefined } from '@philips-internal/oswald-ui-utils';
import { LOCALES } from '../metadata/types.js';
function getLocaleProps(props, locale) {
    if (isUndefined(props)) {
        return {};
    }
    const locales = props[LOCALES];
    if (isUndefined(locales)) {
        return {};
    }
    const foundLocale = locales[locale];
    return foundLocale ? { ...foundLocale } : {};
}
export { getLocaleProps, };
//# sourceMappingURL=get-locale-props.js.map